import Place from "./Place";

export default Place;
export { Place };
